import React from "react";
import Button from '@mui/material/Button';
import { Modal } from "@material-ui/core";
import "./SuccessModal.scss";


const SuccessModal = ({ onClose, title, description }) => {

    const handleCloseModal = () => {
        onClose();
    }

    return (
        <>
            {(
                <Modal
                    open={true}
                    onClose={handleCloseModal}
                    className="modal-container">
                    <div className="pop-up-modal-ok-pay col-sm-10 col-xl-6 container">
                        <Button className="col close-icon" id="redirect-button" onClick={handleCloseModal}>
                            <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                            </svg></span>
                        </Button>
                        <div className="col-12 ok-content-container px-5 mt-5">
                            <div className="ok-content">
                                <div>
                                    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zm18.478 28a2 2 0 0 1 .034 2.828L40.607 57.274a3.001 3.001 0 0 1-4.196.096L25.095 46.792a2 2 0 1 1 2.732-2.922l10.6 9.909 21.222-21.745A2.002 2.002 0 0 1 62.478 32z" fill="#00CE49" />
                                    </svg>
                                </div>
                                <div>
                                    <h2>{title}</h2>
                                </div>
                                <div className="text-center">
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal >
            )}
        </>
    );
}

export default SuccessModal;
